/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { SET_HELP_OPTIONS_LIST, SET_HELP_SELECTED_OPTION } from './help.types';
import { IHelpSelectedOption } from './IHelpSelectedOption';

export const setHelpListAction = (
    optionsList: Array<IHelpSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IHelpSelectedOption>;
}> => ({
    type: SET_HELP_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedHelpOptionAction = (
    selectedOption?: IHelpSelectedOption,
): TivoPayloadAction<{ selectedOption?: IHelpSelectedOption }> => ({
    type: SET_HELP_SELECTED_OPTION,
    payload: { selectedOption },
});
